import React, { useEffect } from 'react';
import { useImmer } from 'use-immer';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import _ from 'lodash';
import { Button, Modal, Form, Col, Alert } from 'react-bootstrap';
import FormControls, { ConditionalRender } from '../formControls';

const queueValidation = Yup.object().shape({
    name: Yup.string().required('Queue name is required.')
        .min(5, 'Queue name must contain more than five characters.')
        .max(300, 'Queue name must have less than 300 characters.')
});

const CreateCodingEventQueueModal = (props) => {
    //const [queue, setQueue] = useImmer({ id: null, name: "", state: 100 });
    const [saveError, setSaveError] = useImmer(null);

    const formik = useFormik({
        initialValues: { id: null, name: "", state: 100 },
        validationSchema: queueValidation,
        enableReinitialize: true,
        onSubmit: async (values, { setSubmitting, setErrors, setStatus, resetForm }) => {
            var result = await props.saveModel(values)
            if (!result.result) {
                setSaveError(result.message);
            }
            setSubmitting(false);
        }
    });

    return (
        <>
            <Modal.Header>Create new coding event queue</Modal.Header>
            <Modal.Body>
                <Form.Row>
                    <Alert variant='danger' show={saveError}>{saveError}</Alert>
                    <Form.Group as={Col} lg="12" md="12" controlId="name">
                        <FormControls.Textbox
                            name="name"
                            label="Queue Name"
                            formHandler={formik} />
                    </Form.Group>
                </Form.Row>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="light" onClick={props.hideModal}>Cancel</Button>
                <Button variant="primary" onClick={() => formik.submitForm()}>Save</Button>
            </Modal.Footer>
        </>
    );
}

export default CreateCodingEventQueueModal;